module.exports = __webpack_public_path__ + "img/eye-closed.e76fdaa0.svg";